import { z } from "zod";
// A dataset snapshot's column descriptor (mirrors @veritab/clients DatasetColumn).
export const datasetColumnSchema = z.object({
    key: z.string(),
    label: z.string(),
    type: z.enum(["text", "number", "date"]),
});
// Catalog entry: everything about a materialized dataset except its rows.
// This is also the chat-AI discovery surface — title/description tell the
// model what the data means; columns tell it what it can chart.
export const datasetCatalogItemSchema = z.object({
    datasetId: z.string(),
    title: z.string(),
    description: z.string(),
    columns: z.array(datasetColumnSchema),
    rowCount: z.number().int(),
    syncedAt: z.coerce.date(),
});
export const datasetListResponseSchema = z.object({
    datasets: z.array(datasetCatalogItemSchema),
});
// A dataset row: column key → primitive value.
export const datasetRowSchema = z.record(z.string(), z.union([z.string(), z.number(), z.null()]));
export const datasetDataQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(10000).optional(),
    offset: z.coerce.number().int().min(0).optional(),
});
export const datasetDataResponseSchema = z.object({
    datasetId: z.string(),
    title: z.string(),
    columns: z.array(datasetColumnSchema),
    rows: z.array(datasetRowSchema),
    /** Total rows in the snapshot (before limit/offset). */
    rowCount: z.number().int(),
    syncedAt: z.coerce.date(),
});
